<template>
  <div>
    <!-- FAB -->
    <button id="openChatBtn" class="chatbot-floating-button" @click="openChatbot()"
      v-show="!(isMobile ? !!currentMobileView : isChatOpen)">
      <i class="fa-solid fa-message-bot"></i>
    </button>

    <!-- CHAT SIDEBAR -->
    <div id="chatSidebar" class="chatbot-sidebar"
      :style="{ display: isMobile ? (currentMobileView ? 'block' : 'none') : (isChatOpen ? 'block' : 'none'), zIndex: 50002 }">

      <!-- HISTORY -->
      <transition name="history-slide">
        <div id="historySidebar" class="chatbot-history-sidebar px-3" v-show="isHistoryOpen" aria-hidden="false">
          <!-- Header history: pulsante a SINISTRA come il burger dell’header chat -->
          <div class="d-flex align-items-center justify-content-between px-2 py-2 chatbot-header-bar">
            <div class="d-flex align-items-center">
              <button class="chrome-btn mr-2" id="closeHistoryBtn" @click="closeHistory()" aria-label="Chiudi storico">
                <i class="fa-solid fa-arrow-right"></i>
              </button>
              <p class="mb-0 ml-2 chatbot-header-title">HR Intelligence assistance</p>
            </div>
            <!-- placeholder a destra per mantenere centraggio identico -->
            <button class="chrome-btn" style="visibility:hidden">
              <i class="fa-solid fa-circle-xmark"></i>
            </button>
          </div>

          <!-- Nuova conversazione dentro l’overlay -->
          <button class="history-new-btn mt-3 px-3" @click="newConversationFromHistory">
            <i class="fa-solid fa-pen-to-square chatbot-icon-brand"></i>
            {{__('forms.chatbot.new_chat')}}
          </button>

          <h6 class="mt-2 mb-1 px-3 chatbot-section-title">{{__('forms.chatbot.crono_history')}}
          </h6>

          <div class="chatbot-history-wrapper">
            <ul class="history-list">
              <li v-for="c in conversations" :key="c.id"
                :class="['history-item', { active: c.id === (conversation && conversation.id) }]"
                @click="selectConversation(c.id)">
                <i class="fa-regular fa-message"></i>
                <span class="history-item-title">{{ c.title }}</span>
              </li>

              <!-- Stato vuoto -->
              <li v-if="!this.isWaitingForHistory() && conversations.length === 0" class="history-empty">
                <i class="fa-regular fa-inbox"></i>
                <span>{{__('forms.chatbot.no_conv_found')}}</span>
              </li>

              <li v-if="hasMore && !this.isWaitingForHistory()" class="history-more" @click="loadMoreHistory()">
                <i class="fa-solid fa-angles-down"></i> {{__('forms.chatbot.load_other')}}
              </li>

              <li v-if="this.isWaitingForHistory()" class="history-loading">
                <div class="spinner-border" role="status" style="width:20px;height:20px"></div>
                <span class="ml-2">{{__('forms.chatbot.loading_convs')}}</span>
              </li>
            </ul>
          </div>
        </div>
      </transition>

      <!-- Header chat -->
      <div class="d-flex align-items-center justify-content-between px-2 py-2 chatbot-header-bar">
        <div class="d-flex align-items-center">
          <button class="chrome-btn mr-2" id="openHistoryBtn" @click="openHistory()">
            <i class="fa-solid fa-bars"></i>
          </button>
          <p class="mb-0 ml-2 chatbot-header-title">HR Intelligence assistance</p>
        </div>
        <button class="chrome-btn" id="closeChatBtn" @click="closeChatbot()">
          <i class="fa-solid fa-circle-xmark"></i>
        </button>
      </div>

      <!-- Contenuti chat -->
      <div class="chatbot-content mt-2" ref="chatContent">
        <!-- WELCOME top -->
        <div v-if="!thereIsAConversation()" class="welcome-top p-4">
          <div class="welcome-copy">
            <div class="welcome-header">
              <h1 class="welcome-title text-primary"> <i class="fa-solid fa-message-bot mr-2"></i>
                {{__('forms.chatbot.welcome_message')}}
              </h1>
            </div>
            <p class="welcome-subtitle mt-1">
              {{__('forms.chatbot.welcome_goal')}}
            </p>
          </div>
        </div>

        <div v-else>

          <!-- Nessun messaggio trovato -->
          <div v-if="conversation.messages.length == 0" class="text-center mt-2" style="position: relative; top:50%; border-radius:10px;">
            <span class="text-primary" style="font-weight:bold !important;">
              {{__('forms.chatbot.no_conv_send_messag')}}
            </span>
          </div>

          <div v-for="(message, index) in conversation.messages" :key="index" class="d-flex align-items-start mb-2 mx-2">

            <div class="w-100 mt-3">

                <div class="chatbot-message-card chatbot-message-card-user-color" v-html="message.text"></div>
              
                <div class="chatbot-message-card chatbot-message-card-chatbot-color mt-4" v-html="sanitizeMarkdown(message.response)"></div>

                <!-- Loader Function Calling -->
                <div v-if="message.tool != null && message.tool.name != null" class="tool-call-waiting my-3 d-flex flex-column align-items-center justify-content-center">
                  <div class="text-center mb-2" style="font-size:14px">
                    {{__('forms.chatbot.in_wait_load_fun')}} {{ message.tool.human_name !== null ? message.tool.human_name : message.tool.name }}
                  </div>
                  <div class="rocket-anim-wrapper">
                    <i class="fa-solid fa-rocket-launch rocket-anim"></i>
                  </div>
                </div>


                <!-- Fonti Documentali-->
                <div v-if="message.documents && message.documents.length && (index !== conversation.messages.length - 1 || !isWaitingToEndResponse())" class="chat-sources">
                    <div class="chat-sources__title">Fonti:</div>
                    <ul class="chat-sources__list">
                    <li v-for="(doc, dIdx) in message.documents" :key="dIdx">
                        <i class="fa-solid fa-file-lines"></i>
                        <a :href="`/download-media-from-chatbot/${doc.id}`" target="_blank" rel="noopener">{{ doc.name }}</a>
                    </li>
                    </ul>
                </div>

                <!-- Fonti API-->
                <div v-if="message.assistantResponses && message.assistantResponses.length && (index !== conversation.messages.length - 1 || !isWaitingToEndResponse())" class="chat-sources">
                    <div class="chat-sources__title">Funzioni:</div>
                    <ul class="chat-sources__list">
                      <li v-for="(assistantResponse, arId) in message.assistantResponses" :key="arId">                        
                        <div v-for="(toolCall, tcId) in assistantResponse.toolCalls" :key="tcId">
                          <i class="fa-solid fa-rocket-launch"></i>
                          <span>
                            {{ toolCall.tool.human_name !== null ? toolCall.tool.human_name : toolCall.tool.name }}
                          </span>
                        </div>
                      </li>
                    </ul>
                </div>

                <!-- Feedback -->
                <div class="chat-feedback" v-if="(index !== conversation.messages.length - 1 || !isWaitingToEndResponse())">
                    <button class="fb-btn" :class="{ active: message.feedback === 'POSITIVE' }" @click="setFeedback(message, 'POSITIVE')" aria-label="Utile">
                        <i class="fa-regular fa-thumbs-up"></i>
                    </button>
                    <button class="fb-btn" :class="{ active: message.feedback === 'NEGATIVE' }" @click="setFeedback(message, 'NEGATIVE')" aria-label="Non utile">
                        <i class="fa-regular fa-thumbs-down"></i>
                    </button>
                    <span v-if="message.feedback && message.feedbackUpdatedAt" class="fb-thanks">
                        {{__('forms.chatbot.thk_for_feedback')}}                        
                    </span>
                </div>

                 <!-- Form commento visibile dopo il click su 👍/👎 -->
              <div v-if="message.openFeedbackTextArea" class="feedback-form">

                <label class="feedback-form__label">
                  <i :class="message.feedback === 'POSITIVE' ? 'fa-regular fa-thumbs-up' : 'fa-regular fa-thumbs-down'"></i>
                  <span v-if="message.feedback === 'POSITIVE'">
                    {{__('forms.chatbot.feedback_comment_title_positive')}}
                  </span>
                  <span v-if="message.feedback === 'NEGATIVE'">
                    {{__('forms.chatbot.feedback_comment_title_negative')}}
                  </span>
                </label>
                
                <textarea v-model="message.feedbackComment" :placeholder="message.feedback === 'POSITIVE'  ? __('forms.chatbot.feedback_comment_placeholder_positive')  : __('forms.chatbot.feedback_comment_placeholder_negative')"></textarea>

                <div class="feedback-form__actions">
                  <button class="feedback-submit" @click="submitFeedback(message)">{{__('forms.chatbot.send')}}</button>
                  <button class="feedback-cancel" @click="cancelFeedback(message)">{{__('forms.chatbot.undo')}}</button>
                </div>

              </div>

            </div>

          </div>

        </div>
      </div>

      <!-- Loader template (nascosti) -->
      <div hidden ref="messageContentLoader" class="chat-message-loader mt-2">
        <div class="chat-loader-inner">
          <span class="chat-loader-icon">
            <span class="chat-loader-ring"></span>
          </span>
          <span class="chat-loader-text">
            {{__('forms.chatbot.loading_wait_for_response')}}            
          </span>
        </div>
      </div>


      <!-- Writer -->
    <div class="chatbot-input">

      <div class="chatbot-input__box">
        <textarea class="chatbot-input__textarea" placeholder="Chiedi a HR Intelligence assistance..." v-model="writedMessage"
          :disabled="this.isWaitingForResponse()" @keydown.enter.exact.prevent="send"></textarea>

        <button class="chatbot-input__send" :disabled="this.isWaitingForResponse() || !canSend" @click="send"
          aria-label="Invia">
          <i class="fa-solid fa-paper-plane"></i>
        </button>
      </div>

      <p class="chatbot-input__disclaimer">
        {{ __('forms.chatbot.disclaimer') }}
      </p>

    </div>

    </div>

  </div>
</template>

<script>
import ChatbotSDK from "@hrtools/chatbot-sdk"
import { marked } from 'marked';

export default {
  props: {
    user_avatar: { type: String, required: true },
    chatbot_url: { type: String, required: true },
  },

  mounted() {

    this.initLayout();

    this.initConversation();

    this.initChatbotSDK();    

  },

  beforeDestroy() {
    this.addResizeListner();
  },

  data() {
    return {
      chatbotSDK: null,
      chatbotKeyToken: "6254bc5b-236a-4116-aa6f-54d15f8375af",
      chatbotToken: null,
      _tokenPromise: null,
      writedMessage: null,
      conversation: null,
      conversations: [],
      waitingForHistory: false,
      waitingForResponse: false,
      waitingForToolCallResponse: false,
      waitingToEndResponse: false,
      toolNameCalled: null,      
      limit: 30,
      offset: 0,
      hasMore: false,
      isMobile: false,
      currentMobileView: null,
      isChatOpen: false,
      isHistoryOpen: false,
      descriptors: [],
      JWT : {
        token: null,
        ttl: null,
        startTime: null
      },      
    }
  },

  computed: {
    canSend() {
      return this.writedMessage && this.writedMessage.trim().length > 0;
    }
  },
  
  methods: {

    sanitizeMarkdown(text) {
      return marked.parse(text || "");
    },

    // #region init methods

    initLayout() {

      if (this.checkMobile()) {

        this.initMobile();

      }
    },

    checkMobile() {

      this.isMobile = window.innerWidth < 768;

      if (this.isMobile && this.isHistoryOpen) {

        this.currentMobileView = 'history'

      };
    },

    initMobile() {

      this.addResizeListner();

      const mobileBtn = document.getElementById('openChatBtnMobile');

      if (mobileBtn) {

        mobileBtn.addEventListener('click', () => this.openChatbot())
      };

    },

    addResizeListner() {

      window.addEventListener('resize', this.checkMobile);

    },

    initConversation(id = null, time = null) {
      this.conversation = {
        id: id,
        creationTimestamp: time,
        messages: []
      };
    },

    initChatbotSDK() {

      this.getJWTToken().then((response) => {
        
        this.JWT.token = response.data.token;

        this.JWT.ttl = response.data.ttl;

        this.JWT.ttl;

        //Refresh token when expired
        setTimeout(() => {
          this.initChatbotSDK()
        }, this.JWT.ttl * 1000);

        this.JWT.startTime = Date.now();

         if (!this.JWT.token) {

            throw new Error("Token non ricevuto");

          }

        this.chatbotSDK = new ChatbotSDK({ baseUrl: this.chatbot_url + "/api" });

        this.chatbotSDK.setAuthToken(this.JWT.token);

        this.getChatbotApiDescriptors();

      });
    },

    getChatbotApiDescriptors() {

      let svc = this;
      this.getChatbotDescriptors().then((response) => {
        svc.descriptors = response.data;        
      })

    },

    // #endregion

    // #region chat flow

    send() {

      if (!this.checkUserCanSend()) {
        return;
      }

      this.startWaitingForResponse();

      let message = this.createEmptyMessage(this.writedMessage);

      this.writedMessage = null;

      if (!this.thereIsAConversation()) {

        const title = this.generateTitleConversation(message.text);

        this.createConversation(title).then((response) => {

            this.conversation = response.data;

            this.sendMessage(message);

          })
          .catch((error) => {

            this.pushErrorMessage(error);

          });

      } else {

        this.sendMessage(message);

      }

    },

    async checkUserCanSend() {

      let result = true;

      if (!this.canSend || this.isWaitingForResponse()) {

        result = false;

      }

      try {

        await this.ensureToken();

      } catch (e) {

        this.pushErrorMessage(e);

        result = false;
      }

      return result;

    },

    async ensureToken() {

      if (this.JWT.token == null) {

        this.initChatbotSDK();

      }

    },

    generateTitleConversation(firstMessage) {

      let result = "New conversation";

      if (firstMessage) {

        result = firstMessage.substring(0, 30);

        if (firstMessage.length > 30) result += "...";

      }

      return result;
    },

    thereIsAConversation() {
      return !!(this.conversation && this.conversation.id);
    },

    createEmptyMessage(text) {

      return {
        id: null,
        status: null,
        text: text,
        response: this.$refs.messageContentLoader.getHTML(),
        originalResponse: "",
        error: null,
        feedback: null,
        feedbackComment: null,
        feedbackUpdatedAt: null,
        openFeedbackTextArea: false,
        chunks: [],
        documents: [],
        assistantResponses: [],
        waitingResponse: false,
        tool: {
          name: null,
          human_name: null,
          id: null
        }
      }
    },

    createAssistantResponse(toolCalls) {
      return {
        id: null,
        response: null,
        iteration: null,
        creationTimestamp: null,
        toolCalls: toolCalls ?? []
      }
    },

    createToolCall(hrtId, chbId, name, svc) {

      let human_name = svc.retriveDescriptionHuman(name);
      
      return {
        id: hrtId,
        tool: {
          id: chbId,
          name: name,
          human_name: human_name
        }
      };
    },

    retriveDescriptionHuman(name) {

      let human_name = null;
      if (this.descriptors != null) {
        if (this.descriptors.hasOwnProperty(name)) {
           human_name = this.descriptors[name].human_name;
        }
      }
      return human_name;
    },

    async sendMessage(message) {

      let index = this.addMessageToConversation(message);

      const stream = await this.addMessageToChat(message.text);

      const svc = this;

      for await (const item of stream.complete) {

        if (svc.isWaitingForResponse()) {

          svc.stopWaitingForResponse();

          message.response = "";

        }

        message.id = stream.messageId;

        switch (item.type) {

          case "CHUNK": {

            if (message.tool != null && message.tool.name != null) {
              //Clean response.
              message.response = "";
            }

            message.tool = {
              name: null,
              human_name: null,
              id: null
            };

            message.response += item.content; 

            break;
          }
          case "TOOL_CALL_START": {

            message.tool = item.tool;

            message.tool.human_name = svc.retriveDescriptionHuman(item.tool.name);

            let assistantResponse = svc.createAssistantResponse();

            assistantResponse.toolCalls.push(svc.createToolCall(null,item.tool.id,item.tool.name, svc))

            message.assistantResponses.push(assistantResponse);

            break;
          }
          case "TOOL_CALL_END": {

            break;
          }
          case "END": {

            message.documents = svc.makeUniqueDocuments(item.data.documents);

            svc.stopWaitingToEndResponse();

            break;
          }

          default: break;

        }

        svc.conversation.messages[index] = message;

        svc.scrollToEnd();

      }

    },

    makeUniqueDocuments(documents) {

        const uniqueDocs = [];
    
        documents.forEach(doc => {
    
            if (!uniqueDocs.some(d => d.id === doc.id)) {
    
            uniqueDocs.push(doc);
    
            }
    
        });
    
        return uniqueDocs;

    },

    addMessageToConversation(message) {

      this.conversation.messages.push(message);

      this.scrollToEnd();

      return this.conversation.messages.length - 1;

    },

    pushErrorMessage(error) {
      console.log(error);
    },

    async addMessageToChat(messageToSend) {

      return await this.chatbotSDK.chat({
        conversationId: this.conversation.id,
        prompt: messageToSend,
        stream: true
      });

    },
    
    // #endregion

    // #region waiting flag

    startWaitingForResponse() {
      this.waitingForResponse = true;
      this.startWaitingToEndResponse();
    },

    stopWaitingForResponse() {
      this.waitingForResponse = false;
    },

    isWaitingForResponse()  {
      return this.waitingForResponse;
    },

    startWaitingToEndResponse() {
      this.waitingToEndResponse = true;
    },

    stopWaitingToEndResponse() {
      this.waitingToEndResponse = false;
    },

    isWaitingToEndResponse() {
      return this.waitingToEndResponse;
    },

    startWaitingForToolCallResponse() {
      this.waitingForToolCallResponse = true;
    },

    stopWaitingForToolCallResponse() {
      this.waitingForToolCallResponse = false;
    },

    isWaitingForToolCallResponse() {
      return this.waitingForToolCallResponse;
    },

    startWaitingForHistory() {
      this.waitingForHistory = true;
    },

    stopWaitingForHistory() {
      this.waitingForHistory = false;
    },

    isWaitingForHistory() {
      return this.waitingForHistory;
    },

    // #endregion

    // #region API Hrtools

    getJWTToken() {
      return axios.get("/api/chatbot/token");
    },

    createConversation(title) {
      return axios.post("/api/chatbot/conversation/" + this.JWT.token, { title });
    },

    getHistoryConversations() {
      return axios.get("/api/chatbot/conversation/" + this.JWT.token + "/" + this.limit + "/" + this.offset);
    },

    getChatbotDescriptors() {      
      return axios.get("/api/chatbot/descriptors");
    },

    // #endregion

    // #region Feedback

    setFeedback(message, value) {

      if (message.feedbackUpdatedAt) {

        //Siamo nel contesto in cui il feedback è già stato salvato a db
        if (message.feedback === value) {

          //Siamo nel caso in cui l'utente toglie il feedback
          message.feedback = null;
          message.feedbackComment = '';
          message.openFeedbackTextArea = false;

          this.submitFeedback(message);

        } else {

          //Siamo nel caso in cui l'utente clicca sui pollici per aggiungere un feedback
          message.feedback = value;
          message.openFeedbackTextArea = true;

        }

      } else {

        //Siamo nel contesto in cui il feedback non è ancora stato salvato a db

        if (message.feedback === value) {

          //Siamo nel caso in cui l'utente toglie il feedback
          message.feedback = null;
          message.feedbackComment = '';
          message.openFeedbackTextArea = false;

        } else {

          //Siamo nel caso in cui l'utente cambia il feedback
          message.feedback = value;
          message.openFeedbackTextArea = true;

        }
      }
    },

    async submitFeedback(message) {

      let response = await this.chatbotSDK.setMessageFeedback({
        messageId: message.id,
        feedback: message.feedback,
        feedbackComment: message.feedbackComment
      });

      message.feedbackUpdatedAt = response.message.feedbackUpdatedAt;
      message.openFeedbackTextArea = false;
    },

    async cancelFeedback(message) {
      message.feedback = null;
      message.feedbackComment = '';
      if (message.feedbackUpdatedAt) {
        this.submitFeedback(message);
      }
      message.openFeedbackTextArea = false;
    },

    // #endregion

    // #region mobile

    showHistoryMobile() {
      this.currentMobileView = 'history';
      this.isHistoryOpen = true;
    },

    showChatMobile() {
      this.currentMobileView = 'chat';
      this.isHistoryOpen = false;
    },

    // #endregion

    // #region history

    async openHistory() {

      this.isHistoryOpen = true;

      if (this.isMobile) {
        this.currentMobileView = 'history';
      }
      else {
        this.isChatOpen = true;
      }

      try {

        await this.ensureToken();

        if (this.conversations.length === 0) {

          await this.loadConversations();

        }

      } catch (e) {

        this.pushErrorMessage(e);

      }
    },

    closeHistory() {

      this.isHistoryOpen = false;

      if (this.isMobile && this.currentMobileView === 'history') {
        this.currentMobileView = 'chat';
      }

    },

    async selectConversation(conversationId) {

      try {

        await this.ensureToken();

      } catch (e) {

        this.pushErrorMessage(e); return;

      }

      this.closeHistory();

      const prevConv = this.conversation;

      this.startWaitingForResponse();

      this.chatbotSDK.getConversation({ conversationId }).then((response) => {

          this.conversation = this.extractDocumentsFromHistoryConversation(response);

          this.conversation = this.extractHumanNameFromHistoryConversation(response);

          this.stopWaitingToEndResponse();

        })
        .catch((error) => {

          this.conversation = this.extractDocumentsFromHistoryConversation(prevConv);

          this.pushErrorMessage(error);

        })
        .finally(() => {

          this.stopWaitingForResponse();

          this.scrollToEnd();

        });
    },

    extractDocumentsFromHistoryConversation(conversation) {

        conversation.messages.forEach(message => {
            if (message.documents === undefined) {
                message.documents = [];
            }
            message.chunks.forEach(chunk => {
                if (chunk.document != null && !message.documents.some(doc => doc.id === chunk.document.id)) {
                    message.documents.push(chunk.document);
                }
            });
        });

        return conversation;
        
    },

    extractHumanNameFromHistoryConversation(conversation) {

      let svc = this;

      conversation.messages.forEach(message => {
          if (message.assistantResponses && Array.isArray(message.assistantResponses)) {
            message.assistantResponses.forEach((assistantResponse) => {
              if (assistantResponse.toolCalls && Array.isArray(assistantResponse.toolCalls)) {
                assistantResponse.toolCalls.forEach((toolCall) => {
                  if (toolCall.tool && toolCall.tool.name){
                    toolCall.tool.human_name = svc.retriveDescriptionHuman(toolCall.tool.name);
                  }                                  
                });
              }
            });
          }
        });

      return conversation;
    },

    async loadMoreHistory() {
      this.limit += 10;
      await this.loadConversations();
    },

    async loadConversations() {

      this.startWaitingForHistory();

      try {

        await this.ensureToken();

        const response = await this.getHistoryConversations();

        this.conversations = response.data.conversations || [];

        this.limit = response.data.limit ?? this.limit;

        this.offset = response.data.offset ?? this.offset;

        this.hasMore = !!response.data.hasMore;

      } catch (error) {

        this.pushErrorMessage(error);

      } finally {

        this.stopWaitingForHistory();

      }
    },

    openChatbot() {

      if (this.isMobile) {

        this.currentMobileView = 'chat';

      } else {

        this.isChatOpen = true;

      }
    },

    closeChatbot() {

      if (this.isMobile) {

        this.currentMobileView = null;

        this.isHistoryOpen = false;

      } else {

        this.isChatOpen = false;

        this.isHistoryOpen = false;

      }
    },

    scrollToEnd() {

      const container = this.$refs.chatContent;

      if (container) container.scrollTop = container.scrollHeight * 2;

    },

    // #endregion

    // #region new conversation

    newConversationFromHistory() {

      this.newConversation();

      this.closeHistory();

    },

    newConversation() {

      this.initConversation();
      
    },

    // #endregion

    addDots(text) {
      return "..." + text + "...";
    }
  }
}
</script>

<style>
:root {  /* OK */
  --chat-gutter-x: 24px;
  --chat-gutter-bottom: 16px;
  --chat-input-min-h: 112px;
  --icon-btn-size: 40px;
  --placeholder-color: #98A2B3;
  --placeholder-color-focus: #B8C1CC;
  --brand: #1767a2;
  --brand-2: #dde8ff;
  --ink: #0F172A;
  --slate-600: #475569;
  --border: #EEF2F6;
}

@media (max-width: 767px) { /* OK */
  :root {
    --chat-gutter-x: 16px;
    --chat-input-min-h: 120px;
    --icon-btn-size: 40px;
  }
}


.chatbot-floating-button { /* OK */
  position: fixed;
  bottom: 20px;
  right: 20px;
  z-index: 50001;
  padding: 8px;
  background-color: var(--brand);
  color: #fff;
  border: none;
  border-radius: 50%;
  box-shadow: 0 6px 12px rgba(0, 0, 0, .15);
  cursor: pointer;
  font-size: 18px;
  height: 50px;
  width: 50px;
  transition: transform .3s ease, box-shadow .3s ease, background-color .2s;
}

.chatbot-floating-button:hover {  /* OK */
  background: var(--brand-2); 
  transform: translateY(-3px);
}


.chatbot-sidebar { /* OK */
  position: fixed;
  top: 0;
  right: 0;
  width: 600px;
  height: 100%;
  background: #fff;
  box-shadow: -2px 0 5px rgba(0, 0, 0, .071);
  z-index: 50002;
  border-radius: 10px 0 0 10px;
  padding: 10px;
  display: flex;
  flex-direction: column;
}


.chatbot-history-sidebar { /* OK */
  position: absolute;
  inset: 0;
  background: #fff;
  z-index: 60010;
  box-shadow: -2px 0 8px rgba(0, 0, 0, .08);
  border-radius: 10px 0 0 10px;
  padding: 10px !important;
  display: flex;
  flex-direction: column;
  height: 100%;
  overflow: hidden;
}


#historySidebar { /* OK */
  padding: 10px !important;
  box-shadow: -2px 0 8px rgba(0, 0, 0, .06);
}

.history-slide-enter-active #historySidebar,
.history-slide-leave-active #historySidebar { /* OK */
  box-shadow: -4px 0 18px rgba(0, 0, 0, .10);
}


#historySidebar .history-section { /* OK */
  margin: 12px 0 8px 0 !important;
  font-size: 14px !important;
  font-weight: 600 !important;
  color: #36455B !important;
}


#historySidebar .chatbot-history-wrapper { /* OK */
  flex: 1 1 auto !important;
  min-height: 0 !important;
  overflow: auto !important;
  padding: 0 8px 12px 8px !important;
  max-height: none !important;
  height: auto !important;
}

#historySidebar .history-new-btn { /* OK */
  border: none;
  outline: none;
  -webkit-appearance: none;
  appearance: none;
  background: transparent;
  color: #1767A2;
  border-radius: 12px;
  padding: 12px 14px;
  font-weight: semi-bold;
  font-size: 16px;
  width: 100%;
  display: flex;
  align-items: center;
  gap: 8px;
  text-align: left;
  margin-top: 12px !important;
}

#historySidebar .history-new-btn:hover { /* OK */
  background: #EDF4FF !important;
  border-color: #1767A2 !important;
}

#historySidebar .history-list { /* OK */
  list-style: none !important;
  margin: 0 !important;
  padding: 0 !important;
}

#historySidebar .history-item { /* OK */
  display: flex !important;
  align-items: center !important;
  gap: 8px !important;
  padding: 8px 10px !important;
  border-radius: 10px !important;
  cursor: pointer !important;
  color: #334155 !important;
  font-size: 14px !important;
  border: 0 !important;
  transition: background .12s ease !important;
}

#historySidebar .history-item:hover { /* OK */
  background: #F7F8FA !important;
}

#historySidebar .history-item.active { /* OK */
  background: #EBF3FF !important;
  color: #1767A2 !important;
  font-weight: 600 !important;
}

#historySidebar .history-item i { /* OK */
  min-width: 16px !important;
  text-align: center !important;
  color: #1767A2 !important;
}

#historySidebar .history-item-title { /* OK */
  white-space: nowrap !important;
  overflow: hidden !important;
  text-overflow: ellipsis !important;
}

#historySidebar .history-empty { /* OK */
  display: flex !important;
  align-items: center !important;
  gap: 8px !important;
  color: #9CA3AF !important;
  font-size: 14px !important;
  padding: 8px 10px !important;
}

#historySidebar .history-empty i { /* OK */
  color: #9CA3AF !important;
}

#historySidebar .history-more { /* OK */
  color: #1767A2 !important;
  font-weight: 600 !important;
  cursor: pointer !important;
  padding: 8px 10px !important;
  border-radius: 8px !important;
}

#historySidebar .history-more:hover { /* OK */
  background: #EDF4FF !important;
}

#historySidebar .history-loading { /* OK */
  display: flex !important;
  align-items: center !important;
  gap: 8px !important;
  color: #6B7280 !important;
  font-size: 14px !important;
  padding: 8px 10px !important;
}


.chatbot-content { /* OK */
  position: relative;
  height: 74vh;
  display: flex;
  flex-direction: column;
  overflow-y: auto;
  background-size: cover;
  padding: 10px var(--chat-gutter-x) calc(var(--chat-input-min-h) + var(--chat-gutter-bottom) + 8px);
  flex: 1 1 auto;
  min-height: 0;
  padding-bottom: 0 !important;

    p {
      font-size: 14px;
      line-height: 1.5;
      margin: 0 0 8px;
    }

    
    h1,
    h2,
    h3,
    h4,
    h5,
    h6 {
      margin: 10px 0;
      font-weight: 700;
      color: #1767A2;
    }

    
    h1 { font-size: 22px; }
    h2 { font-size: 20px; }
    h3 { font-size: 18px; }
    h4 { font-size: 16px; }
    h5 { font-size: 14px; }
    h6 { font-size: 12px; }

    
    ul,
    ol {
      margin: 8px 0 10px 20px;
      padding-left: 20px;
      font-size: 14px;
    }

    ul {
      list-style-type: disc;
    }

    ol {
      list-style-type: decimal;
    }

    li {
      margin-bottom: 4px;
    }

    
    a {
      color: #1767A2;
      text-decoration: underline;
    }

    a:hover {
      text-decoration: none;
    }

    
    strong,
    b {
      font-weight: 600;
    }

}


.chatbot-human-avatar,
.chatbot-chat-avatar {  /* OK */
  border-radius: 50%;
  display: none !important;
}

.chatbot-chat-avatar { /* OK */
  margin-right: .25rem;
}

.chatbot-message-card { /* OK */
  width: 100%;
  padding: 20px;
  border-radius: 15px;
  color: #fff;
  box-shadow: 0 4px 8px rgba(0, 0, 0, .12) !important;
}

.chatbot-message-card-chatbot-color { /* OK */
  background: var(--brand-2);
}


.chat-sources { /* OK */
  margin-top: 10px;
}

.chat-sources__title { /* OK */
  font-size: 14px;
  font-weight: 700;
  color: #1767A2;
  ;
}

.chat-sources__list { /* OK */
  list-style: none;
  margin: 0;
  padding: 0;
}

.chat-sources__list li { /* OK */
  display: flex;
  align-items: center;
  gap: 8px;
  padding: 6px 0;
}

.chat-sources__list li:last-child { /* OK */
  border-bottom: 0;
}

.chat-sources__list i { /* OK */
  color: #1767A2;
  font-size: 12px;
  min-width: 14px;
}

.chat-sources__list a { /* OK */
  color: #333333;
  font-weight: 600;
  text-decoration: underline;
  font-size: 12px;
}

.chat-sources__list a:hover { /* OK */
  text-decoration: underline;
  color: #1767A2;
}

.chat-feedback { /* OK */
  display: flex;
  align-items: center;
  gap: 8px;
  margin-top: 10px;
  border-top: 1px solid #E5EDF6;
  padding-top: 10px;
}

.fb-btn { /* OK */
  width: 28px;
  height: 28px;
  border: 1px solid #D7E4F2;
  background: #F8FBFF;
  border-radius: 6px;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  color: #1767A2;
  cursor: pointer;
  transition: transform .08s ease, background .15s ease, border-color .15s ease;
}

.fb-btn:hover { /* OK */
  background: #EDF4FF;
  border-color: #1767A2;
}

.fb-btn.active { /* OK */
  background: #1767A2;
  border-color: #1767A2;
  color: #fff;
}

.fb-thanks { /* OK */
  font-size: 12px;
  color: #1F6FA8;
  margin-left: 6px;
}


.chatbot-input { /* OK */
  position: absolute !important;
  left: var(--chat-gutter-x) !important;
  right: var(--chat-gutter-x) !important;
  bottom: var(--chat-gutter-bottom) !important;
  z-index: 5 !important;
  min-height: var(--chat-input-min-h);
}

.chatbot-input::before { /* OK */
  content: "";
  position: absolute;
  left: -16px;
  right: -16px;
  top: -28px;
  height: 28px;
  background: linear-gradient(to top, rgba(255, 255, 255, 1), rgba(255, 255, 255, 0));
  pointer-events: none;
}

.chatbot-input__textarea { /* OK */
  width: 100%;
  min-height: var(--chat-input-min-h);
  max-height: 240px;
  padding: 18px calc(var(--icon-btn-size) + 20px) 18px 20px;
  border: none;
  border-radius: 12px;
  background: #F5FAFF;
  box-shadow: 0 4px 4px rgba(0, 0, 0, .04);
  resize: vertical;
  outline: none;
  font-size: 16px;
  line-height: 1.35;
  color: var(--ink);
}

.chatbot-input__textarea::placeholder {  /* OK */
  color: var(--placeholder-color);
  opacity: 1;
}

.chatbot-input__textarea:focus::placeholder { /* OK */
  color: var(--placeholder-color-focus);
}

.chrome-btn { /* OK */
  background: transparent;
  border: none;
  color: var(--brand);
  font-size: 20px;
  width: 40px;
  height: 40px;
  display: inline-flex;
  align-items: center;
  justify-content: center;
}

.chrome-btn:hover { /* OK */
  color: var(--brand-2);
}

.chatbot-input__send { /* OK */
  position: absolute;
  right: 18px;
  bottom: 16px;
  width: var(--icon-btn-size);
  height: var(--icon-btn-size);
  border: none;
  border-radius: 50%;
  background: var(--brand);
  color: #fff;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  box-shadow: 0 6px 12px rgba(23, 103, 162, .25);
  transition: transform .08s ease, box-shadow .2s ease, background-color .2s ease;
  cursor: pointer;
  font-size: 14px;
}

.chatbot-input__send:hover { /* OK */
  background: var(--brand-2);
  transform: translateY(-1px);
}

.chatbot-input__send:disabled { /* OK */
  background: #CBD5E1;
  box-shadow: none;
  cursor: not-allowed;
  opacity: .9;
  transform: none;
}


@media (max-width: 767px) { /* OK */
  .chatbot-sidebar {
    width: 100vw !important;
    border-radius: 0 !important;
    top: 60px !important;
    height: calc(100% - 60px) !important;
  }

  #openChatBtnMobile { /* OK */
    display: none !important;
  }

  .chatbot-history-sidebar { /* OK */
    inset: 0 !important;
    top: auto !important;
    height: 100% !important;
    border-radius: 0 !important;
    right: 0 !important;
    width: 100vw !important;
    z-index: 60000 !important;
  }

  #historySidebar .chatbot-history-wrapper { /* OK */
    max-height: none !important;
    height: auto !important;
  }

  .chatbot-content { /* OK */
    height: 65vh;
    padding: 20px var(--chat-gutter-x) calc(var(--chat-input-min-h) + var(--chat-gutter-bottom) + 16px);
  }

}


.chatbot-chat-div-textarea { /* OK */
  display: none !important;
}

.chatbot-chat-textarea { /* OK */
  all: unset;
}

.chat-error-message>div:first-child,
.chat-error-message>div:last-child { /* OK */
  display: none !important;
}


.history-slide-enter-active,
.history-slide-leave-active { /* OK */
  transition:
    transform .24s cubic-bezier(.2, .8, .2, 1),
    opacity .24s cubic-bezier(.2, .8, .2, 1),
    box-shadow .24s ease;
  will-change: transform, opacity;
}

.history-slide-enter,
.history-slide-leave-to { /* OK */
  transform: translateX(12px);
  opacity: 0;
}


#closeHistoryBtn i { /* OK */
  transition: transform .12s ease;
}

#closeHistoryBtn:active i { /* OK */
  transform: translateX(1px);
}


@media (prefers-reduced-motion: reduce) {  /* OK */

  .history-slide-enter-active,
  .history-slide-leave-active {
    transition: none !important;
  }
}


.chatbot-content .chatbot-message-card { /* OK */
  background: transparent !important;
  color: var(--ink) !important;
  padding: 0 !important;
  border-radius: 0 !important;
  box-shadow: none !important;
  width: auto !important;
}


.chatbot-content .chatbot-message-card-chatbot-color { /* OK */
  background: transparent !important;
  width: 100% !important;
  padding: 0 !important;
  box-shadow: none !important;
  color: var(--ink) !important;
}


.chatbot-content .chatbot-message-card-user-color { /* OK */
  background: var(--brand) !important;
  max-width: 72% !important;
  padding: 14px 16px !important;
  border-radius: 14px !important;
  margin-left: auto !important;
  box-shadow: 0 4px 8px rgba(0, 0, 0, .12) !important;
  color: #fff !important;
  display: block !important;
  width: fit-content !important;
  font-size:14px;
}


.chatbot-content .chatbot-message-card-chatbot-error { /* OK */
  background: #F04649 !important;
  color: #fff !important;
  padding: 14px 16px !important;
  border-radius: 12px !important;
  box-shadow: 0 4px 8px rgba(0, 0, 0, .12) !important;
  font-size:14px;
}


.chatbot-content .chatbot-message-card p+* { /* OK */
  margin-top: 1rem;
}


.feedback-form { /* OK */
  margin-top: 10px;
  padding: 10px 12px;
  border: 1px solid #E5EDF6;
  border-radius: 10px;
  background: #F9FBFF;
}

.feedback-form__label { /* OK */
  display: flex;
  align-items: center;
  gap: 8px;
  font-weight: 600;
  font-size: 13px;
  color: #1F6FA8;
  margin-bottom: 6px;
}

.feedback-form textarea { /* OK */
  width: 100%; 
  min-height: 68px;
  resize: vertical;
  border: 1px solid #D7E4F2;
  border-radius: 8px;
  padding: 10px 12px;
  outline: none;
  background: #fff;
}

.feedback-form textarea:focus { /* OK */
  border-color: #1767A2;
  box-shadow: 0 0 0 3px rgba(23, 103, 162, .12);
}

.feedback-form__actions { /* OK */
  display: flex;
  align-items: center;
  gap: 8px;
  margin-top: 8px;
}

.feedback-submit { /* OK */
  border: none;
  background: #1767A2;
  color: #fff;
  border-radius: 8px;
  padding: 8px 12px;
  font-size: 13px;
  font-weight: 600;
  cursor: pointer;
}

.feedback-submit:hover { /* OK */
  background: #1F8EDE;
}

.feedback-cancel { /* OK */
  background: transparent;
  border: none;
  color: #64748B;
  font-size: 13px;
  cursor: pointer;
}

.feedback-form__thanks { /* OK */
  margin-top: 8px;
  font-size: 12px;
  color: #1F6FA8;
}


.tool-call-waiting { /* OK */
    background-color: #f5f5f5;
    border-radius: 8px;
    width: 50%;
    margin: 0 auto;
    padding: 16px;
    background-color: #1767A2;
    color: white;
}

.rocket-anim-wrapper { /* OK */
    position: relative;
    width: 100px;
    height: 30px;
    overflow: hidden;
}

.rocket-anim { /* OK */
    position: absolute;
    bottom: 5px;
    left: 5px;
    animation: rocket-flight 3s linear infinite;
    font-size: 20px;
    color: #000000;
}

@keyframes rocket-flight { /* OK */
    0% {
        left: 0%;
        transform: rotate(45deg);
        color: #fff;
    }
    100% {
        left: 100%;
        transform: rotate(45deg);
        color: #F04649;
    }
}

.chat-message-loader {
  width: 100%;
  padding: 10px 16px;
}

.chat-loader-inner {
  display: inline-flex;
  align-items: center;
  gap: 10px;
  font-size: 0.875rem; /* 14px */
  font-style: italic;
  color: var(--slate-600, #475569);
}

/* Icona cerchio animato */
.chat-loader-icon {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 22px;
  height: 22px;
}

.chat-loader-ring {
  box-sizing: border-box;
  width: 22px;
  height: 22px;
  border-radius: 999px;
  border: 2px solid rgba(23, 103, 162, 0.15); /* alone ring */
  border-top-color: var(--brand, #1767A2);     /* colore brand */
  animation: chat-loader-spin 0.8s linear infinite;
}

/* Animazione rotazione */
@keyframes chat-loader-spin {
  to {
    transform: rotate(360deg);
  }
}

/* Responsive: leggermente più piccolo su mobile */
@media (max-width: 767px) {
  .chat-loader-inner {
    font-size: 0.8rem;
  }

  .chat-loader-icon {
    width: 20px;
    height: 20px;
  }

  .chat-loader-ring {
    width: 20px;
    height: 20px;
  }
}

.chatbot-input__box {
  position: relative;        
}

.chatbot-input__disclaimer {
  margin-top: 6px;
  font-size: 11px;
  line-height: 1.4;
  color: #64748B;
  text-align: center;
}

/* ── Classi riutilizzabili header/brand (usano var(--brand) per tematizzazione) ── */
.chatbot-header-bar {
  border-bottom: 2px solid var(--brand);
}

.chatbot-header-title {
  font-weight: bold;
  color: var(--brand);
  font-size: 16px;
}

.chatbot-icon-brand {
  color: var(--brand);
  font-size: 20px;
}

.chatbot-section-title {
  font-weight: bold;
  color: var(--brand);
  font-size: 16px;
}


</style>